import React from 'react'

export const DocumentosAdministrativos = () => {
    return (
        <div>
            <span>Documentos Administrativos</span>
        </div>
    )
}
